import { BettingTypeLookup } from "@api-types/betting-types";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";
export default class BettingTypesApiService {
	static baseUrl = `${WEBPACK_BASE_ADDRESS}platform/betting-types`;

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};
	static async findLookup(): Promise<BettingTypeLookup> {
		const context = getApiRequestContext();
		return httpClient.get(
			`${this.baseUrl}?rpp=2000&translate=true`,
			this.getRequestHeaders(context)
		);
	}
}
